module.exports = "https://cdn2-fs.clearscore.com/flux/images/348b686020ffcf283013e1b9235ba7bb.jpg";